import type { IFormData, IFormDataOptions } from '@/types/forms';

const formData = (name: string, obj: IFormDataOptions): IFormData => {
  if (name) {
    const pattern = /^(\w+)\[(\d+)\]\.(\w+)$/;
    const matches = name.match(pattern);
    if (matches) {
      const dynamicValue = matches[1];
      const number = matches[2];
      const text = matches[3];
      if (
        dynamicValue &&
        number &&
        text &&
        obj.errors[dynamicValue] &&
        obj.errors[dynamicValue][number] &&
        obj.errors[dynamicValue][number][text]
      ) {
        return {
          register: obj.register,
          error: obj.errors[dynamicValue][number][text],
          touched: obj.errors[dynamicValue][number][text],
        };
      }
    }
  }

  return {
    register: obj.register,
    error: obj.errors[name],
    touched: obj.touchedFields[name],
  };
};

const parseInputType = (type: string): Record<string, string> => {
  if (type === 'numeric') {
    return {
      type: 'text',
      inputmode: 'numeric',
    };
  }

  return { type };
};

export { formData, parseInputType };
